const DeleteOutlineIcon = ({ className = '' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      className={className}
    >
      <path
        d='M3.3335 5.83333H16.6668H3.3335ZM13.3335 5.83333V3.33333C13.3335 3.11232 13.2457 2.90036 13.0894 2.74408C12.9331 2.5878 12.7212 2.5 12.5002 2.5H7.50016C7.27915 2.5 7.06719 2.5878 6.91091 2.74408C6.75463 2.90036 6.66683 3.11232 6.66683 3.33333V5.83333H13.3335ZM15.0002 16.6667V5.83333H5.00016V16.6667C5.00016 16.8877 5.08796 17.0996 5.24424 17.2559C5.40052 17.4122 5.61248 17.5 5.8335 17.5H14.1668C14.3878 17.5 14.5998 17.4122 14.7561 17.2559C14.9124 17.0996 15.0002 16.8877 15.0002 16.6667Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DeleteOutlineIcon;
